<template>

    <button @click="clicked($event)" v-if="userPermissions['edit']" class="btn btn-update border border-dark">
        <slot></slot>
    </button>

</template>

<script>

import PermissionButtonsHelperMixin from './PermissionButtonsHelperMixin';

export default{

    mixins: [PermissionButtonsHelperMixin],
};

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/permission-buttons/UpdateButton.vue